import validate from '@/utils/validations/name'

export default {
    validate,
    message: 'Digite um Nome e Sobrenome válidos',
}